import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
import { getTitleByPickedColors } from '../utils/get-title-by-picked-colors';

export type ReceptionTypes =
    | 'type-1-big'
    | 'type-1-small'
    | 'type-2-big'
    | 'type-2-small'
    | 'type-1-small-left'
    | 'type-1-small-right'
    | 'type-2-small-left'
    | 'type-2-small-right';
const receptionTypesArray = [
    'type-1-big',
    'type-1-small',
    'type-2-big',
    'type-2-small',
    'type-1-small-left',
    'type-1-small-right',
    'type-2-small-left',
    'type-2-small-right',
];
export const isReception = (value: string) => receptionTypesArray.includes(value);

export type TVTypes = 'smallTv' | 'bigTv';
const tvTypesArray = ['smallTv', 'bigTv'];
export const isTvType = (value: string) => tvTypesArray.includes(value);

export type LightsTypes = 'lamp' | 'spot';
const lightTypesArray = ['lamp', 'spot'];
export const isLightsType = (value: string) => lightTypesArray.includes(value);

const furnitureTypesArray = [
    '2-chairs-table',
    '4-chairs-table',
    '2-bar-chairs-table',
    'sofa-2-chairs',
    'sofa-1-chair',
    'none',
] as const;

export type FurnitureTypes = (typeof furnitureTypesArray)[number];

export const isFurnitureType = (value: FurnitureTypes) => furnitureTypesArray.includes(value);

const exhibitTypesArray = [
    'wheel',
    'crankshaft',
    'crankshaft-2',
    'tubes',
    'tubes-small',
    'engine',
    'combo',
    'helicopter',
    'none',
] as const;

export type ExhibitTypes = (typeof exhibitTypesArray)[number];

export const isExhibitType = (value: ExhibitTypes) => exhibitTypesArray.includes(value);

export type BooleTypes =
    | 'glass-left'
    | 'glass-center'
    | 'glass-right'
    | 'glass-front-left'
    | 'glass-front-center'
    | 'glass-front-right'
    | 'glass-side-near'
    | 'glass-side-far'
    | 'glass-side-center';
const booleTypesArray = ['first', 'second', 'third', 'fourth', 'fifth'];
export const isBooleType = (value: string) => booleTypesArray.includes(value);

export type PartitionTypes = 'single' | 'duo' | 'duo-with-shell' | 'none-partition';
const partitionTypesArray = ['single', 'duo', 'duo-with-shell', 'none-partition'];
export const isPartitionType = (value: string) => partitionTypesArray.includes(value);

type ModelStateItem<T> = {
    title: string;
    value: T;
};

export type ModelState = {
    color: ModelStateItem<(string | null)[]>;
    openedWallColorPickerIndex: number | null;
    reception: ModelStateItem<ReceptionTypes>;
    tvFirst?: ModelStateItem<TVTypes>;
    tvSecond?: ModelStateItem<TVTypes>;
    exhibit?: ModelStateItem<ExhibitTypes>;
    exhibitSecond?: ModelStateItem<ExhibitTypes>;
    lightsFirst?: ModelStateItem<LightsTypes>;
    lightsSecond?: ModelStateItem<LightsTypes>;
    furnitureFirst?: ModelStateItem<FurnitureTypes>;
    furnitureSecond?: ModelStateItem<FurnitureTypes>;
    boole?: ModelStateItem<BooleTypes>[];
    partition?: ModelStateItem<PartitionTypes>;
};

export const currentModelDefaultState: ModelState = {
    color: {
        title: getTitleByPickedColors([]),
        value: [],
    },
    openedWallColorPickerIndex: null,
    reception: {
        title: 'Большая',
        value: 'type-1-big',
    },
};

const currentModelState = atom<ModelState>({
    key: 'currentModelState',
    default: currentModelDefaultState,
});

export const useCurrentModelStateValue = () => useRecoilValue(currentModelState);

export const useSetCurrentModelState = () => useSetRecoilState(currentModelState);
